import { HttpResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  Subject,
  Observable,
  takeUntil,
  of,
  catchError,
  finalize,
  map,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  startWith,
  switchMap,
  tap,
} from 'rxjs';
// Models
import {
  UrbanAreasBasicInfo,
  MultipleApiResponse,
  User,
} from '@mocca-technologies/model';
// Services
import { OperationsService } from 'src/app/services/operations.service';

@Component({
  selector: 'app-check-near-urban-areas',
  templateUrl: './check-near-urban-areas.component.html',
  styleUrls: ['./check-near-urban-areas.component.scss'],
})
export class CheckNearUrbanAreasComponent implements OnInit, OnDestroy {
  user = JSON.parse(localStorage.getItem('user')) as User;
  private _radius = 3000;
  radiusInput = 3000;

  isLoading = false;

  @Output() urbanAreasSearch = new EventEmitter<UrbanAreasBasicInfo[]>();
  @Output() radiusChange = new EventEmitter<void>();
  @Output() refreshCenter = new EventEmitter<void>();
  // REMOVED:
  // @Output() loadingChange = new EventEmitter<boolean>();

  private destroy$ = new Subject<void>();

  private position$ = new Subject<{ lat: number; lon: number }>();
  private radius$ = new Subject<number>();

  constructor(
    private cdr: ChangeDetectorRef,
    private operationService: OperationsService,
  ) {}

  get radius(): number {
    return this._radius;
  }

  set radius(value: number) {
    this._radius = value;
  }

  onRadiusChange() {
    const value = Number(this.radiusInput);
    if (!Number.isFinite(value) || value <= 0) return;

    if (value !== this._radius) {
      this._radius = value;
      this.radiusChange.emit();
      this.radius$.next(this._radius);
    }
  }

  ngOnInit() {
    combineLatest([
      this.position$.pipe(
        debounceTime(250),
        distinctUntilChanged((a, b) => a.lat === b.lat && a.lon === b.lon),
      ),
      this.radius$.pipe(startWith(this._radius)),
    ])
      .pipe(
        takeUntil(this.destroy$),
        switchMap(([pos, r]) => {
          this.isLoading = true;

          const radius = r + r / 3;

          return this.operationService
            .getNearUrbanAreasBasicInfo(pos.lat, pos.lon, radius, this.user?.username, this?.user?.hashPassword)
            .pipe(
              map((res: HttpResponse<MultipleApiResponse>) => {
                return (res.body?.responseObject ?? []) as UrbanAreasBasicInfo[];
              }),
              catchError(() => of([] as UrbanAreasBasicInfo[])),
              finalize(() => {
                this.isLoading = false;
                this.cdr.detectChanges();
              }),
            );
        }),
        tap((urbanAreas) => this.urbanAreasSearch.emit(urbanAreas)),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updatePosition(latitude: number, longitude: number) {
    this.position$.next({ lat: latitude, lon: longitude });
  }
}
